import { ApiException } from '../interface/ApiException';
import { ApiError } from '../interface/ApiError';

export const toErrorMessage = (error: ApiException<ApiError> | any, appendToDefaultMessage: string = ''): string => {
  return error?.body?.message || `Es ist ein Fehler aufgetreten. ${appendToDefaultMessage}`;
};
